import {
	useFormErrorNotification,
	useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { $api } from "../generated/client";
import type { ReturnRequestDto } from "../generated/schema";

interface UseEditBillingAddressParams {
	onSuccess: (returnRequest: ReturnRequestDto) => void;
}

export default function useEditBillingAddress(
	params: UseEditBillingAddressParams,
) {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();

	return $api.useMutation(
		"patch",
		"/shops/{shopId}/return-requests/{returnRequestId}/billing-address",
		{
			onSuccess(returnRequest) {
				successNotification();
				params.onSuccess(returnRequest);
			},
			onError() {
				errorNotification();
			},
		},
	);
}
